import React, {
  FC,
  HTMLAttributes,
  useState,
  FormEvent,
  useContext,
  ReactNode,
  useEffect,
} from 'react'
import { ButtonRestyled, Menu } from 'out-game/components'
import { makeStyles } from '@material-ui/core'
import { useTranslationStrict } from 'out-game/hooks'
import { Currency } from 'out-game/root/types'
import { currencyContext } from 'out-game/root/CurrencyContext'
import CurrencySelect from './CurrencySelect'
import { Color } from 'out-game/constants'
import { setCurrencyContext } from 'out-game/root/CurrencyContext/context'

const CURRENCY_LABELS: { [key in Currency]: ReactNode } = {
  [Currency.rub]: 'RUB',
  [Currency.usd]: 'USD',
  [Currency.eur]: 'EUR',
}

const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexFlow: 'column',
  },
  submitButton: {
    width: 200,
    height: 35,
    margin: '30px auto 0',
  },
  currency: {
    margin: '0 8px',
    color: Color.Red,
    fontSize: 22
  },
})

// TODO: исправить перерендеры в шапке из-за нотификаций
const LanguageMenu: FC<HTMLAttributes<HTMLDivElement>> = React.memo((props) => {
  const { t } = useTranslationStrict()

  const classes = useStyles()

  const { currency: contextCurrency } =
    useContext(currencyContext)

  const setContextCurrency = useContext(setCurrencyContext)

  const [currency, setCurrency] = useState<Currency>(contextCurrency)

  useEffect(() => {
    setCurrency(contextCurrency)
  }, [contextCurrency])

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (currency) {
      setContextCurrency(currency)
    }
  }

  const menuHeader = (
    <span className={classes.currency}>
      {CURRENCY_LABELS[contextCurrency]}
    </span>
  )

  return (
    <Menu Header={menuHeader} withArrow={false} {...props}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <CurrencySelect value={currency} onChange={setCurrency} />

        <ButtonRestyled
          variant="green"
          type="submit"
          className={classes.submitButton}
        >
          {t('save')}
        </ButtonRestyled>
      </form>
    </Menu>
  )
})

export default LanguageMenu
